import React from 'react'

const UserAddress = (props) =>  {

    return (
        <div className="login-page">
            login page            
        </div>
    )
}

export default UserAddress;